// extracted by mini-css-extract-plugin
module.exports = {"reviewFormWrapper":"styles_reviewFormWrapper__1dHDa","main_section":"styles_main_section__3BLo5","buttons":"styles_buttons__1rSML","backBtn":"styles_backBtn__29fPf"};